var map = {
	"./core0.png": "iu8f",
	"./core1.png": "pcfh"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2UgM";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/left ^\.\/core.*\.png$
// module id = 2UgM
// module chunks = 3